import { render } from "./News33.vue?vue&type=template&id=22fa25ef"
import script from "./News33.vue?vue&type=script&lang=js"
export * from "./News33.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__